//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { AuthorizedApiBase } from "./AuthorizedApiBase";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * _AdminBeginCsvExport
     * @param body (optional) 
     * @return OK
     */
    _AdminBeginCsvExport(body: BeginCsvExport_Request | undefined): Promise<BeginCsvExport_Response> {
        let url_ = this.baseUrl + "/_admin/begin-csv-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.process_AdminBeginCsvExport(_response);
        });
    }

    protected process_AdminBeginCsvExport(response: Response): Promise<BeginCsvExport_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BeginCsvExport_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BeginCsvExport_Response>(null as any);
    }

    /**
     * AgentLogin
     * @param body (optional) 
     * @return OK
     */
    agentLogin(body: Agents_LoginRequest | undefined): Promise<Agents_LoginResponse> {
        let url_ = this.baseUrl + "/agents/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAgentLogin(_response);
        });
    }

    protected processAgentLogin(response: Response): Promise<Agents_LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Agents_LoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Agents_LoginResponse>(null as any);
    }

    /**
     * CustomerCreate
     * @param body (optional) 
     * @return OK
     */
    customerCreate(body: Create_Request | undefined): Promise<Create_Response> {
        let url_ = this.baseUrl + "/customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerCreate(_response);
        });
    }

    protected processCustomerCreate(response: Response): Promise<Create_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Create_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Create_Response>(null as any);
    }

    /**
     * CustomerAddressCreate
     * @param body (optional) 
     * @return OK
     */
    customerAddressCreate(customerId: string, body: AddressCreate_Request | undefined): Promise<any> {
        let url_ = this.baseUrl + "/customers/{customerId}/address";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerAddressCreate(_response);
        });
    }

    protected processCustomerAddressCreate(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * CustomerComplianceCreate
     * @param body (optional) 
     * @return OK
     */
    customerComplianceCreate(customerId: string, body: ComplianceCreate_Request | undefined): Promise<any> {
        let url_ = this.baseUrl + "/customers/{customerId}/compliance";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerComplianceCreate(_response);
        });
    }

    protected processCustomerComplianceCreate(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * CustomerBeneficiaryCreate
     * @param body (optional) 
     * @return OK
     */
    customerBeneficiaryCreate(customerId: string, body: BeneficiaryCreate_Request | undefined): Promise<BeneficiaryCreate_Response> {
        let url_ = this.baseUrl + "/customers/{customerId}/beneficiaries";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerBeneficiaryCreate(_response);
        });
    }

    protected processCustomerBeneficiaryCreate(response: Response): Promise<BeneficiaryCreate_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BeneficiaryCreate_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BeneficiaryCreate_Response>(null as any);
    }

    /**
     * CustomerDependantCreate
     * @param body (optional) 
     * @return OK
     */
    customerDependantCreate(customerId: string, body: DependantCreate_Request | undefined): Promise<DependantCreate_Response> {
        let url_ = this.baseUrl + "/customers/{customerId}/dependants";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerDependantCreate(_response);
        });
    }

    protected processCustomerDependantCreate(response: Response): Promise<DependantCreate_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DependantCreate_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DependantCreate_Response>(null as any);
    }

    /**
     * CustomerPremiumCreate
     * @param body (optional) 
     * @return OK
     */
    customerPremiumCreate(customerId: string, body: PremiumCreate_Request | undefined): Promise<any> {
        let url_ = this.baseUrl + "/customers/{customerId}/premium";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerPremiumCreate(_response);
        });
    }

    protected processCustomerPremiumCreate(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * CustomerPremiumAccept
     * @param body (optional) 
     * @return OK
     */
    customerPremiumAccept(customerId: string, body: PremiumAccept_Request | undefined): Promise<any> {
        let url_ = this.baseUrl + "/customers/{customerId}/premium/accept";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerPremiumAccept(_response);
        });
    }

    protected processCustomerPremiumAccept(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * PaymentTypesGetAll
     * @return OK
     */
    paymentTypesGetAll(): Promise<PaymentTypes_PaymentTypeDto[]> {
        let url_ = this.baseUrl + "/payment-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPaymentTypesGetAll(_response);
        });
    }

    protected processPaymentTypesGetAll(response: Response): Promise<PaymentTypes_PaymentTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentTypes_PaymentTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentTypes_PaymentTypeDto[]>(null as any);
    }

    /**
     * GetProductByTenantID
     * @return OK
     */
    getProductByTenantID(): Promise<Products_ProductDto> {
        let url_ = this.baseUrl + "/products";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductByTenantID(_response);
        });
    }

    protected processGetProductByTenantID(response: Response): Promise<Products_ProductDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Products_ProductDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Products_ProductDto>(null as any);
    }

    /**
     * ProductsGet
     * @return OK
     */
    productsGet(productId: string): Promise<Products_ProductDto> {
        let url_ = this.baseUrl + "/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProductsGet(_response);
        });
    }

    protected processProductsGet(response: Response): Promise<Products_ProductDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Products_ProductDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Products_ProductDto>(null as any);
    }

    /**
     * /healthz
     * @return OK
     */
    healthz(): Promise<any> {
        let url_ = this.baseUrl + "/healthz";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthz(_response);
        });
    }

    protected processHealthz(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export enum CustomerAddressEntity_MaritalStatuses {
    Single = "Single",
    Married = "Married",
    Divorced = "Divorced",
    LivingTogether = "LivingTogether",
}

export enum CustomerAddressEntity_SourcesOfFunds {
    Salary = "Salary",
    RentalIncome = "RentalIncome",
    Investment = "Investment",
    Annuity = "Annuity",
    Other = "Other",
}

export enum CustomerBeneficiaryEntity_BeneficiaryType {
    PrimaryBeneficiary = "PrimaryBeneficiary",
    SecondaryBeneficiary = "SecondaryBeneficiary",
}

export enum CustomerDependantEntity_DependantType {
    Spouse = "Spouse",
    Parent = "Parent",
    Child = "Child",
    ExtendedFamily = "ExtendedFamily",
}

export class ProductEntity_DetailsJson implements IProductEntity_DetailsJson {
    ageTiers!: { [key: string]: ProductEntity_DetailsJson_AgeTierJson[]; } | undefined;
    rates!: ProductEntity_DetailsJson_RatesJson;

    constructor(data?: IProductEntity_DetailsJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.rates = data.rates && !(<any>data.rates).toJSON ? new ProductEntity_DetailsJson_RatesJson(data.rates) : <ProductEntity_DetailsJson_RatesJson>this.rates;
        }
        if (!data) {
            this.rates = new ProductEntity_DetailsJson_RatesJson();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["ageTiers"]) {
                this.ageTiers = {} as any;
                for (let key in _data["ageTiers"]) {
                    if (_data["ageTiers"].hasOwnProperty(key))
                        (<any>this.ageTiers)![key] = _data["ageTiers"][key] ? _data["ageTiers"][key].map((i: any) => ProductEntity_DetailsJson_AgeTierJson.fromJS(i)) : [];
                }
            }
            this.rates = _data["rates"] ? ProductEntity_DetailsJson_RatesJson.fromJS(_data["rates"]) : new ProductEntity_DetailsJson_RatesJson();
        }
    }

    static fromJS(data: any): ProductEntity_DetailsJson {
        data = typeof data === 'object' ? data : {};
        let result = new ProductEntity_DetailsJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ageTiers) {
            data["ageTiers"] = {};
            for (let key in this.ageTiers) {
                if (this.ageTiers.hasOwnProperty(key))
                    (<any>data["ageTiers"])[key] = (<any>this.ageTiers)[key];
            }
        }
        data["rates"] = this.rates ? this.rates.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProductEntity_DetailsJson {
    ageTiers: { [key: string]: ProductEntity_DetailsJson_AgeTierJson[]; } | undefined;
    rates: IProductEntity_DetailsJson_RatesJson;
}

export class ProductEntity_DetailsJson_AgeTierJson implements IProductEntity_DetailsJson_AgeTierJson {
    min!: number;
    max!: number | undefined;
    rate!: number;

    constructor(data?: IProductEntity_DetailsJson_AgeTierJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): ProductEntity_DetailsJson_AgeTierJson {
        data = typeof data === 'object' ? data : {};
        let result = new ProductEntity_DetailsJson_AgeTierJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IProductEntity_DetailsJson_AgeTierJson {
    min: number;
    max: number | undefined;
    rate: number;
}

export class ProductEntity_DetailsJson_RatesJson implements IProductEntity_DetailsJson_RatesJson {
    guardianRiskBinder!: number;
    triarcBinder!: number;
    commission!: number;
    scorReinsurer!: number;
    margin!: number;
    repatIndividual!: number;
    repatFamily!: number;

    constructor(data?: IProductEntity_DetailsJson_RatesJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guardianRiskBinder = _data["guardianRiskBinder"];
            this.triarcBinder = _data["triarcBinder"];
            this.commission = _data["commission"];
            this.scorReinsurer = _data["scorReinsurer"];
            this.margin = _data["margin"];
            this.repatIndividual = _data["repatIndividual"];
            this.repatFamily = _data["repatFamily"];
        }
    }

    static fromJS(data: any): ProductEntity_DetailsJson_RatesJson {
        data = typeof data === 'object' ? data : {};
        let result = new ProductEntity_DetailsJson_RatesJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guardianRiskBinder"] = this.guardianRiskBinder;
        data["triarcBinder"] = this.triarcBinder;
        data["commission"] = this.commission;
        data["scorReinsurer"] = this.scorReinsurer;
        data["margin"] = this.margin;
        data["repatIndividual"] = this.repatIndividual;
        data["repatFamily"] = this.repatFamily;
        return data;
    }
}

export interface IProductEntity_DetailsJson_RatesJson {
    guardianRiskBinder: number;
    triarcBinder: number;
    commission: number;
    scorReinsurer: number;
    margin: number;
    repatIndividual: number;
    repatFamily: number;
}

export enum Gender {
    Male = "Male",
    Female = "Female",
}

export class CatholicConnectWalletJson implements ICatholicConnectWalletJson {
    $type!: string;
    premiumStartDate!: Date;
    idNumber?: string | undefined;
    passportNumber?: string | undefined;
    debitOrderDay?: DebitOrderDays;

    constructor(data?: ICatholicConnectWalletJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.$type = _data["$type"];
            this.premiumStartDate = _data["premiumStartDate"] ? new Date(_data["premiumStartDate"].toString()) : <any>undefined;
            this.idNumber = _data["idNumber"];
            this.passportNumber = _data["passportNumber"];
            this.debitOrderDay = _data["debitOrderDay"];
        }
    }

    static fromJS(data: any): CatholicConnectWalletJson {
        data = typeof data === 'object' ? data : {};
        let result = new CatholicConnectWalletJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this.$type;
        data["premiumStartDate"] = this.premiumStartDate ? formatDate(this.premiumStartDate) : <any>undefined;
        data["idNumber"] = this.idNumber;
        data["passportNumber"] = this.passportNumber;
        data["debitOrderDay"] = this.debitOrderDay;
        return data;
    }
}

export interface ICatholicConnectWalletJson {
    $type: string;
    premiumStartDate: Date;
    idNumber?: string | undefined;
    passportNumber?: string | undefined;
    debitOrderDay?: DebitOrderDays;
}

export enum DebitOrderDays {
    _1 = 1,
    _7 = 7,
    _15 = 15,
    _20 = 20,
    _25 = 25,
    _26 = 26,
    _27 = 27,
    _30 = 30,
}

export class DebitOrderJson implements IDebitOrderJson {
    $type!: string;
    premiumStartDate!: Date;
    accountType!: string;
    accountNumber!: string;
    branchCode!: string;
    bankName!: string;
    accountHolderName!: string;
    debitOrderDay!: DebitOrderDays;

    constructor(data?: IDebitOrderJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.$type = _data["$type"];
            this.premiumStartDate = _data["premiumStartDate"] ? new Date(_data["premiumStartDate"].toString()) : <any>undefined;
            this.accountType = _data["accountType"];
            this.accountNumber = _data["accountNumber"];
            this.branchCode = _data["branchCode"];
            this.bankName = _data["bankName"];
            this.accountHolderName = _data["accountHolderName"];
            this.debitOrderDay = _data["debitOrderDay"];
        }
    }

    static fromJS(data: any): DebitOrderJson {
        data = typeof data === 'object' ? data : {};
        let result = new DebitOrderJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this.$type;
        data["premiumStartDate"] = this.premiumStartDate ? formatDate(this.premiumStartDate) : <any>undefined;
        data["accountType"] = this.accountType;
        data["accountNumber"] = this.accountNumber;
        data["branchCode"] = this.branchCode;
        data["bankName"] = this.bankName;
        data["accountHolderName"] = this.accountHolderName;
        data["debitOrderDay"] = this.debitOrderDay;
        return data;
    }
}

export interface IDebitOrderJson {
    $type: string;
    premiumStartDate: Date;
    accountType: string;
    accountNumber: string;
    branchCode: string;
    bankName: string;
    accountHolderName: string;
    debitOrderDay: DebitOrderDays;
}

export class PaymentJson implements IPaymentJson {
    premiumStartDate!: Date;

    protected _discriminator: string;

    constructor(data?: IPaymentJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "PaymentJson";
    }

    init(_data?: any) {
        if (_data) {
            this.premiumStartDate = _data["premiumStartDate"] ? new Date(_data["premiumStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentJson {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["premiumStartDate"] = this.premiumStartDate ? formatDate(this.premiumStartDate) : <any>undefined;
        return data;
    }
}

export interface IPaymentJson {
    premiumStartDate: Date;
}

export class BeginCsvExport_Request implements IBeginCsvExport_Request {
    from?: Date | undefined;
    to?: Date | undefined;

    constructor(data?: IBeginCsvExport_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BeginCsvExport_Request {
        data = typeof data === 'object' ? data : {};
        let result = new BeginCsvExport_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface IBeginCsvExport_Request {
    from?: Date | undefined;
    to?: Date | undefined;
}

export class BeginCsvExport_Response implements IBeginCsvExport_Response {
    exported?: number;

    constructor(data?: IBeginCsvExport_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exported = _data["exported"];
        }
    }

    static fromJS(data: any): BeginCsvExport_Response {
        data = typeof data === 'object' ? data : {};
        let result = new BeginCsvExport_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exported"] = this.exported;
        return data;
    }
}

export interface IBeginCsvExport_Response {
    exported?: number;
}

export class Agents_LoginRequest implements IAgents_LoginRequest {
    email!: string;
    password!: string;

    constructor(data?: IAgents_LoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.email = "test@test.com";
            this.password = "testPassword";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : "test@test.com";
            this.password = _data["password"] !== undefined ? _data["password"] : "testPassword";
        }
    }

    static fromJS(data: any): Agents_LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new Agents_LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IAgents_LoginRequest {
    email: string;
    password: string;
}

export class Agents_LoginResponse implements IAgents_LoginResponse {
    token?: string | undefined;
    expiry?: Date;

    constructor(data?: IAgents_LoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expiry = _data["expiry"] ? new Date(_data["expiry"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Agents_LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Agents_LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expiry"] = this.expiry ? this.expiry.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgents_LoginResponse {
    token?: string | undefined;
    expiry?: Date;
}

export class AddressCreate_Request implements IAddressCreate_Request {
    unitNumber?: string | undefined;
    unitName?: string | undefined;
    streetAddress!: string;
    suburb!: string;
    city!: string;
    province!: string;
    postCode!: string;
    occupation!: string;
    salary!: number;
    sourceOfFunds!: CustomerAddressEntity_SourcesOfFunds;
    maritalStatus!: CustomerAddressEntity_MaritalStatuses;

    constructor(data?: IAddressCreate_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitNumber = _data["unitNumber"];
            this.unitName = _data["unitName"];
            this.streetAddress = _data["streetAddress"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.postCode = _data["postCode"];
            this.occupation = _data["occupation"];
            this.salary = _data["salary"];
            this.sourceOfFunds = _data["sourceOfFunds"];
            this.maritalStatus = _data["maritalStatus"];
        }
    }

    static fromJS(data: any): AddressCreate_Request {
        data = typeof data === 'object' ? data : {};
        let result = new AddressCreate_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitNumber"] = this.unitNumber;
        data["unitName"] = this.unitName;
        data["streetAddress"] = this.streetAddress;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["province"] = this.province;
        data["postCode"] = this.postCode;
        data["occupation"] = this.occupation;
        data["salary"] = this.salary;
        data["sourceOfFunds"] = this.sourceOfFunds;
        data["maritalStatus"] = this.maritalStatus;
        return data;
    }
}

export interface IAddressCreate_Request {
    unitNumber?: string | undefined;
    unitName?: string | undefined;
    streetAddress: string;
    suburb: string;
    city: string;
    province: string;
    postCode: string;
    occupation: string;
    salary: number;
    sourceOfFunds: CustomerAddressEntity_SourcesOfFunds;
    maritalStatus: CustomerAddressEntity_MaritalStatuses;
}

export class BeneficiaryCreate_Request implements IBeneficiaryCreate_Request {
    firstName!: string;
    middleName?: string | undefined;
    lastName!: string | undefined;
    relationship!: string;
    cellNumber!: string | undefined;
    type!: CustomerBeneficiaryEntity_BeneficiaryType;
    idNumber?: string | undefined;
    foreignNational?: BeneficiaryCreate_Request_ForeignNationalDto;

    constructor(data?: IBeneficiaryCreate_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.foreignNational = data.foreignNational && !(<any>data.foreignNational).toJSON ? new BeneficiaryCreate_Request_ForeignNationalDto(data.foreignNational) : <BeneficiaryCreate_Request_ForeignNationalDto>this.foreignNational;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.relationship = _data["relationship"];
            this.cellNumber = _data["cellNumber"];
            this.type = _data["type"];
            this.idNumber = _data["idNumber"];
            this.foreignNational = _data["foreignNational"] ? BeneficiaryCreate_Request_ForeignNationalDto.fromJS(_data["foreignNational"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BeneficiaryCreate_Request {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryCreate_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["relationship"] = this.relationship;
        data["cellNumber"] = this.cellNumber;
        data["type"] = this.type;
        data["idNumber"] = this.idNumber;
        data["foreignNational"] = this.foreignNational ? this.foreignNational.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBeneficiaryCreate_Request {
    firstName: string;
    middleName?: string | undefined;
    lastName: string | undefined;
    relationship: string;
    cellNumber: string | undefined;
    type: CustomerBeneficiaryEntity_BeneficiaryType;
    idNumber?: string | undefined;
    foreignNational?: IBeneficiaryCreate_Request_ForeignNationalDto;
}

export class BeneficiaryCreate_Request_ForeignNationalDto implements IBeneficiaryCreate_Request_ForeignNationalDto {
    passportNumber!: string;
    nationality!: string;
    permitType!: string;
    birthDate!: Date;
    gender!: Gender;

    constructor(data?: IBeneficiaryCreate_Request_ForeignNationalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passportNumber = _data["passportNumber"];
            this.nationality = _data["nationality"];
            this.permitType = _data["permitType"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): BeneficiaryCreate_Request_ForeignNationalDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryCreate_Request_ForeignNationalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passportNumber"] = this.passportNumber;
        data["nationality"] = this.nationality;
        data["permitType"] = this.permitType;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : <any>undefined;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IBeneficiaryCreate_Request_ForeignNationalDto {
    passportNumber: string;
    nationality: string;
    permitType: string;
    birthDate: Date;
    gender: Gender;
}

export class BeneficiaryCreate_Response implements IBeneficiaryCreate_Response {
    id?: string;

    constructor(data?: IBeneficiaryCreate_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BeneficiaryCreate_Response {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryCreate_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IBeneficiaryCreate_Response {
    id?: string;
}

export class ComplianceCreate_Request implements IComplianceCreate_Request {
    existingPolicy?: ComplianceCreate_Request_ExistingPolicyDto;
    politicallyExposed?: ComplianceCreate_Request_PoliticallyExposedDto;
    domesticInfluential?: ComplianceCreate_Request_DomesticInfluentialDto;
    foreignPublicOfficial?: ComplianceCreate_Request_ForeignPublicOfficialDto;
    closeAssociate?: ComplianceCreate_Request_CloseAssociateDto;

    constructor(data?: IComplianceCreate_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.existingPolicy = data.existingPolicy && !(<any>data.existingPolicy).toJSON ? new ComplianceCreate_Request_ExistingPolicyDto(data.existingPolicy) : <ComplianceCreate_Request_ExistingPolicyDto>this.existingPolicy;
            this.politicallyExposed = data.politicallyExposed && !(<any>data.politicallyExposed).toJSON ? new ComplianceCreate_Request_PoliticallyExposedDto(data.politicallyExposed) : <ComplianceCreate_Request_PoliticallyExposedDto>this.politicallyExposed;
            this.domesticInfluential = data.domesticInfluential && !(<any>data.domesticInfluential).toJSON ? new ComplianceCreate_Request_DomesticInfluentialDto(data.domesticInfluential) : <ComplianceCreate_Request_DomesticInfluentialDto>this.domesticInfluential;
            this.foreignPublicOfficial = data.foreignPublicOfficial && !(<any>data.foreignPublicOfficial).toJSON ? new ComplianceCreate_Request_ForeignPublicOfficialDto(data.foreignPublicOfficial) : <ComplianceCreate_Request_ForeignPublicOfficialDto>this.foreignPublicOfficial;
            this.closeAssociate = data.closeAssociate && !(<any>data.closeAssociate).toJSON ? new ComplianceCreate_Request_CloseAssociateDto(data.closeAssociate) : <ComplianceCreate_Request_CloseAssociateDto>this.closeAssociate;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existingPolicy = _data["existingPolicy"] ? ComplianceCreate_Request_ExistingPolicyDto.fromJS(_data["existingPolicy"]) : <any>undefined;
            this.politicallyExposed = _data["politicallyExposed"] ? ComplianceCreate_Request_PoliticallyExposedDto.fromJS(_data["politicallyExposed"]) : <any>undefined;
            this.domesticInfluential = _data["domesticInfluential"] ? ComplianceCreate_Request_DomesticInfluentialDto.fromJS(_data["domesticInfluential"]) : <any>undefined;
            this.foreignPublicOfficial = _data["foreignPublicOfficial"] ? ComplianceCreate_Request_ForeignPublicOfficialDto.fromJS(_data["foreignPublicOfficial"]) : <any>undefined;
            this.closeAssociate = _data["closeAssociate"] ? ComplianceCreate_Request_CloseAssociateDto.fromJS(_data["closeAssociate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ComplianceCreate_Request {
        data = typeof data === 'object' ? data : {};
        let result = new ComplianceCreate_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existingPolicy"] = this.existingPolicy ? this.existingPolicy.toJSON() : <any>undefined;
        data["politicallyExposed"] = this.politicallyExposed ? this.politicallyExposed.toJSON() : <any>undefined;
        data["domesticInfluential"] = this.domesticInfluential ? this.domesticInfluential.toJSON() : <any>undefined;
        data["foreignPublicOfficial"] = this.foreignPublicOfficial ? this.foreignPublicOfficial.toJSON() : <any>undefined;
        data["closeAssociate"] = this.closeAssociate ? this.closeAssociate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IComplianceCreate_Request {
    existingPolicy?: IComplianceCreate_Request_ExistingPolicyDto;
    politicallyExposed?: IComplianceCreate_Request_PoliticallyExposedDto;
    domesticInfluential?: IComplianceCreate_Request_DomesticInfluentialDto;
    foreignPublicOfficial?: IComplianceCreate_Request_ForeignPublicOfficialDto;
    closeAssociate?: IComplianceCreate_Request_CloseAssociateDto;
}

export class ComplianceCreate_Request_CloseAssociateDto implements IComplianceCreate_Request_CloseAssociateDto {
    reason!: string;

    constructor(data?: IComplianceCreate_Request_CloseAssociateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ComplianceCreate_Request_CloseAssociateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComplianceCreate_Request_CloseAssociateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IComplianceCreate_Request_CloseAssociateDto {
    reason: string;
}

export class ComplianceCreate_Request_DomesticInfluentialDto implements IComplianceCreate_Request_DomesticInfluentialDto {
    reason!: string;

    constructor(data?: IComplianceCreate_Request_DomesticInfluentialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ComplianceCreate_Request_DomesticInfluentialDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComplianceCreate_Request_DomesticInfluentialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IComplianceCreate_Request_DomesticInfluentialDto {
    reason: string;
}

export class ComplianceCreate_Request_ExistingPolicyDto implements IComplianceCreate_Request_ExistingPolicyDto {
    willCancel?: boolean;
    waitingPeriodExpired?: boolean;
    policyNumber!: string;
    policyName!: string;
    policyPaid?: boolean;
    sameBenefit?: boolean;

    constructor(data?: IComplianceCreate_Request_ExistingPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.willCancel = _data["willCancel"];
            this.waitingPeriodExpired = _data["waitingPeriodExpired"];
            this.policyNumber = _data["policyNumber"];
            this.policyName = _data["policyName"];
            this.policyPaid = _data["policyPaid"];
            this.sameBenefit = _data["sameBenefit"];
        }
    }

    static fromJS(data: any): ComplianceCreate_Request_ExistingPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComplianceCreate_Request_ExistingPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["willCancel"] = this.willCancel;
        data["waitingPeriodExpired"] = this.waitingPeriodExpired;
        data["policyNumber"] = this.policyNumber;
        data["policyName"] = this.policyName;
        data["policyPaid"] = this.policyPaid;
        data["sameBenefit"] = this.sameBenefit;
        return data;
    }
}

export interface IComplianceCreate_Request_ExistingPolicyDto {
    willCancel?: boolean;
    waitingPeriodExpired?: boolean;
    policyNumber: string;
    policyName: string;
    policyPaid?: boolean;
    sameBenefit?: boolean;
}

export class ComplianceCreate_Request_ForeignPublicOfficialDto implements IComplianceCreate_Request_ForeignPublicOfficialDto {
    reason!: string;

    constructor(data?: IComplianceCreate_Request_ForeignPublicOfficialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ComplianceCreate_Request_ForeignPublicOfficialDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComplianceCreate_Request_ForeignPublicOfficialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IComplianceCreate_Request_ForeignPublicOfficialDto {
    reason: string;
}

export class ComplianceCreate_Request_PoliticallyExposedDto implements IComplianceCreate_Request_PoliticallyExposedDto {
    reason!: string;

    constructor(data?: IComplianceCreate_Request_PoliticallyExposedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ComplianceCreate_Request_PoliticallyExposedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComplianceCreate_Request_PoliticallyExposedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IComplianceCreate_Request_PoliticallyExposedDto {
    reason: string;
}

export class Create_Request implements ICreate_Request {
    title!: string;
    firstName!: string;
    middleName?: string | undefined;
    lastName!: string | undefined;
    cellNumber!: string | undefined;
    email!: string;
    idNumber?: string | undefined;
    foreignNational?: Create_Request_ForeignNationalDto;
    popiaConsent?: boolean | undefined;

    constructor(data?: ICreate_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.foreignNational = data.foreignNational && !(<any>data.foreignNational).toJSON ? new Create_Request_ForeignNationalDto(data.foreignNational) : <Create_Request_ForeignNationalDto>this.foreignNational;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.cellNumber = _data["cellNumber"];
            this.email = _data["email"];
            this.idNumber = _data["idNumber"];
            this.foreignNational = _data["foreignNational"] ? Create_Request_ForeignNationalDto.fromJS(_data["foreignNational"]) : <any>undefined;
            this.popiaConsent = _data["popiaConsent"];
        }
    }

    static fromJS(data: any): Create_Request {
        data = typeof data === 'object' ? data : {};
        let result = new Create_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["cellNumber"] = this.cellNumber;
        data["email"] = this.email;
        data["idNumber"] = this.idNumber;
        data["foreignNational"] = this.foreignNational ? this.foreignNational.toJSON() : <any>undefined;
        data["popiaConsent"] = this.popiaConsent;
        return data;
    }
}

export interface ICreate_Request {
    title: string;
    firstName: string;
    middleName?: string | undefined;
    lastName: string | undefined;
    cellNumber: string | undefined;
    email: string;
    idNumber?: string | undefined;
    foreignNational?: ICreate_Request_ForeignNationalDto;
    popiaConsent?: boolean | undefined;
}

export class Create_Request_ForeignNationalDto implements ICreate_Request_ForeignNationalDto {
    passportNumber!: string;
    nationality!: string;
    permitType!: string;
    birthDate!: Date;
    gender!: Gender;

    constructor(data?: ICreate_Request_ForeignNationalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passportNumber = _data["passportNumber"];
            this.nationality = _data["nationality"];
            this.permitType = _data["permitType"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): Create_Request_ForeignNationalDto {
        data = typeof data === 'object' ? data : {};
        let result = new Create_Request_ForeignNationalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passportNumber"] = this.passportNumber;
        data["nationality"] = this.nationality;
        data["permitType"] = this.permitType;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : <any>undefined;
        data["gender"] = this.gender;
        return data;
    }
}

export interface ICreate_Request_ForeignNationalDto {
    passportNumber: string;
    nationality: string;
    permitType: string;
    birthDate: Date;
    gender: Gender;
}

export class Create_Response implements ICreate_Response {
    id?: string;

    constructor(data?: ICreate_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Create_Response {
        data = typeof data === 'object' ? data : {};
        let result = new Create_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreate_Response {
    id?: string;
}

export class DependantCreate_Request implements IDependantCreate_Request {
    firstName!: string;
    middleName?: string | undefined;
    lastName!: string | undefined;
    relationship?: string | undefined;
    email!: string;
    type!: CustomerDependantEntity_DependantType;
    idNumber?: string | undefined;
    foreignNational?: DependantCreate_Request_ForeignNationalDto;

    constructor(data?: IDependantCreate_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.foreignNational = data.foreignNational && !(<any>data.foreignNational).toJSON ? new DependantCreate_Request_ForeignNationalDto(data.foreignNational) : <DependantCreate_Request_ForeignNationalDto>this.foreignNational;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.relationship = _data["relationship"];
            this.email = _data["email"];
            this.type = _data["type"];
            this.idNumber = _data["idNumber"];
            this.foreignNational = _data["foreignNational"] ? DependantCreate_Request_ForeignNationalDto.fromJS(_data["foreignNational"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DependantCreate_Request {
        data = typeof data === 'object' ? data : {};
        let result = new DependantCreate_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["relationship"] = this.relationship;
        data["email"] = this.email;
        data["type"] = this.type;
        data["idNumber"] = this.idNumber;
        data["foreignNational"] = this.foreignNational ? this.foreignNational.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDependantCreate_Request {
    firstName: string;
    middleName?: string | undefined;
    lastName: string | undefined;
    relationship?: string | undefined;
    email: string;
    type: CustomerDependantEntity_DependantType;
    idNumber?: string | undefined;
    foreignNational?: IDependantCreate_Request_ForeignNationalDto;
}

export class DependantCreate_Request_ForeignNationalDto implements IDependantCreate_Request_ForeignNationalDto {
    passportNumber!: string;
    nationality!: string;
    permitType!: string;
    birthDate!: Date;
    gender!: Gender;

    constructor(data?: IDependantCreate_Request_ForeignNationalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passportNumber = _data["passportNumber"];
            this.nationality = _data["nationality"];
            this.permitType = _data["permitType"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): DependantCreate_Request_ForeignNationalDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependantCreate_Request_ForeignNationalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passportNumber"] = this.passportNumber;
        data["nationality"] = this.nationality;
        data["permitType"] = this.permitType;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : <any>undefined;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IDependantCreate_Request_ForeignNationalDto {
    passportNumber: string;
    nationality: string;
    permitType: string;
    birthDate: Date;
    gender: Gender;
}

export class DependantCreate_Response implements IDependantCreate_Response {
    id?: string;

    constructor(data?: IDependantCreate_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DependantCreate_Response {
        data = typeof data === 'object' ? data : {};
        let result = new DependantCreate_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDependantCreate_Response {
    id?: string;
}

export class PremiumAccept_Request implements IPremiumAccept_Request {
    paymentDetails!: PaymentDetails;

    constructor(data?: IPremiumAccept_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.paymentDetails = data.paymentDetails && !(<any>data.paymentDetails).toJSON ? new PaymentDetails(data.paymentDetails) : <PaymentDetails>this.paymentDetails;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDetails = _data["paymentDetails"];
        }
    }

    static fromJS(data: any): PremiumAccept_Request {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumAccept_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDetails"] = this.paymentDetails;
        return data;
    }
}

export interface IPremiumAccept_Request {
    paymentDetails: IPaymentDetails;
}

export class PremiumCreate_Request implements IPremiumCreate_Request {
    productId!: string;
    principal!: PremiumCreate_Request_PrincipalDto;
    family?: PremiumCreate_Request_FamilyDto;
    parents?: PremiumCreate_Request_ParentDto[] | undefined;
    extendedFamilyMembers?: PremiumCreate_Request_ExtendedFamilyMemberDto[] | undefined;
    totalPremium!: number;

    constructor(data?: IPremiumCreate_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.principal = data.principal && !(<any>data.principal).toJSON ? new PremiumCreate_Request_PrincipalDto(data.principal) : <PremiumCreate_Request_PrincipalDto>this.principal;
            this.family = data.family && !(<any>data.family).toJSON ? new PremiumCreate_Request_FamilyDto(data.family) : <PremiumCreate_Request_FamilyDto>this.family;
            if (data.parents) {
                this.parents = [];
                for (let i = 0; i < data.parents.length; i++) {
                    let item = data.parents[i];
                    this.parents[i] = item && !(<any>item).toJSON ? new PremiumCreate_Request_ParentDto(item) : <PremiumCreate_Request_ParentDto>item;
                }
            }
            if (data.extendedFamilyMembers) {
                this.extendedFamilyMembers = [];
                for (let i = 0; i < data.extendedFamilyMembers.length; i++) {
                    let item = data.extendedFamilyMembers[i];
                    this.extendedFamilyMembers[i] = item && !(<any>item).toJSON ? new PremiumCreate_Request_ExtendedFamilyMemberDto(item) : <PremiumCreate_Request_ExtendedFamilyMemberDto>item;
                }
            }
        }
        if (!data) {
            this.productId = "95f9d396-ff0e-4035-9479-db570923bffe";
            this.principal = new PremiumCreate_Request_PrincipalDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : "95f9d396-ff0e-4035-9479-db570923bffe";
            this.principal = _data["principal"] ? PremiumCreate_Request_PrincipalDto.fromJS(_data["principal"]) : new PremiumCreate_Request_PrincipalDto();
            this.family = _data["family"] ? PremiumCreate_Request_FamilyDto.fromJS(_data["family"]) : <any>undefined;
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(PremiumCreate_Request_ParentDto.fromJS(item));
            }
            if (Array.isArray(_data["extendedFamilyMembers"])) {
                this.extendedFamilyMembers = [] as any;
                for (let item of _data["extendedFamilyMembers"])
                    this.extendedFamilyMembers!.push(PremiumCreate_Request_ExtendedFamilyMemberDto.fromJS(item));
            }
            this.totalPremium = _data["totalPremium"];
        }
    }

    static fromJS(data: any): PremiumCreate_Request {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumCreate_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["principal"] = this.principal ? this.principal.toJSON() : <any>undefined;
        data["family"] = this.family ? this.family.toJSON() : <any>undefined;
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item.toJSON());
        }
        if (Array.isArray(this.extendedFamilyMembers)) {
            data["extendedFamilyMembers"] = [];
            for (let item of this.extendedFamilyMembers)
                data["extendedFamilyMembers"].push(item.toJSON());
        }
        data["totalPremium"] = this.totalPremium;
        return data;
    }
}

export interface IPremiumCreate_Request {
    productId: string;
    principal: IPremiumCreate_Request_PrincipalDto;
    family?: IPremiumCreate_Request_FamilyDto;
    parents?: IPremiumCreate_Request_ParentDto[] | undefined;
    extendedFamilyMembers?: IPremiumCreate_Request_ExtendedFamilyMemberDto[] | undefined;
    totalPremium: number;
}

export class PremiumCreate_Request_ExtendedFamilyMemberDto implements IPremiumCreate_Request_ExtendedFamilyMemberDto {
    age!: number;
    cover!: number;

    constructor(data?: IPremiumCreate_Request_ExtendedFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.cover = _data["cover"];
        }
    }

    static fromJS(data: any): PremiumCreate_Request_ExtendedFamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumCreate_Request_ExtendedFamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["cover"] = this.cover;
        return data;
    }
}

export interface IPremiumCreate_Request_ExtendedFamilyMemberDto {
    age: number;
    cover: number;
}

export class PremiumCreate_Request_FamilyDto implements IPremiumCreate_Request_FamilyDto {
    premium!: number;
    waiveredPremium!: number;
    spouse?: PremiumCreate_Request_FamilyDto_SpouseJson;
    children?: PremiumCreate_Request_FamilyDto_ChildrenJson;

    constructor(data?: IPremiumCreate_Request_FamilyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.spouse = data.spouse && !(<any>data.spouse).toJSON ? new PremiumCreate_Request_FamilyDto_SpouseJson(data.spouse) : <PremiumCreate_Request_FamilyDto_SpouseJson>this.spouse;
            this.children = data.children && !(<any>data.children).toJSON ? new PremiumCreate_Request_FamilyDto_ChildrenJson(data.children) : <PremiumCreate_Request_FamilyDto_ChildrenJson>this.children;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.premium = _data["premium"];
            this.waiveredPremium = _data["waiveredPremium"];
            this.spouse = _data["spouse"] ? PremiumCreate_Request_FamilyDto_SpouseJson.fromJS(_data["spouse"]) : <any>undefined;
            this.children = _data["children"] ? PremiumCreate_Request_FamilyDto_ChildrenJson.fromJS(_data["children"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PremiumCreate_Request_FamilyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumCreate_Request_FamilyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["premium"] = this.premium;
        data["waiveredPremium"] = this.waiveredPremium;
        data["spouse"] = this.spouse ? this.spouse.toJSON() : <any>undefined;
        data["children"] = this.children ? this.children.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPremiumCreate_Request_FamilyDto {
    premium: number;
    waiveredPremium: number;
    spouse?: IPremiumCreate_Request_FamilyDto_SpouseJson;
    children?: IPremiumCreate_Request_FamilyDto_ChildrenJson;
}

export class PremiumCreate_Request_FamilyDto_ChildrenJson implements IPremiumCreate_Request_FamilyDto_ChildrenJson {
    amount!: number;

    constructor(data?: IPremiumCreate_Request_FamilyDto_ChildrenJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PremiumCreate_Request_FamilyDto_ChildrenJson {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumCreate_Request_FamilyDto_ChildrenJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPremiumCreate_Request_FamilyDto_ChildrenJson {
    amount: number;
}

export class PremiumCreate_Request_FamilyDto_SpouseJson implements IPremiumCreate_Request_FamilyDto_SpouseJson {
    waiverPremium!: boolean;

    constructor(data?: IPremiumCreate_Request_FamilyDto_SpouseJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waiverPremium = _data["waiverPremium"];
        }
    }

    static fromJS(data: any): PremiumCreate_Request_FamilyDto_SpouseJson {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumCreate_Request_FamilyDto_SpouseJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waiverPremium"] = this.waiverPremium;
        return data;
    }
}

export interface IPremiumCreate_Request_FamilyDto_SpouseJson {
    waiverPremium: boolean;
}

export class PremiumCreate_Request_ParentDto implements IPremiumCreate_Request_ParentDto {
    age!: number;
    cover!: number;

    constructor(data?: IPremiumCreate_Request_ParentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.cover = _data["cover"];
        }
    }

    static fromJS(data: any): PremiumCreate_Request_ParentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumCreate_Request_ParentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["cover"] = this.cover;
        return data;
    }
}

export interface IPremiumCreate_Request_ParentDto {
    age: number;
    cover: number;
}

export class PremiumCreate_Request_PrincipalDto implements IPremiumCreate_Request_PrincipalDto {
    age!: number;
    cover!: number;
    premium!: number;

    constructor(data?: IPremiumCreate_Request_PrincipalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.cover = _data["cover"];
            this.premium = _data["premium"];
        }
    }

    static fromJS(data: any): PremiumCreate_Request_PrincipalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PremiumCreate_Request_PrincipalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["cover"] = this.cover;
        data["premium"] = this.premium;
        return data;
    }
}

export interface IPremiumCreate_Request_PrincipalDto {
    age: number;
    cover: number;
    premium: number;
}

export class PaymentTypes_PaymentTypeDto implements IPaymentTypes_PaymentTypeDto {
    id!: string;
    name!: string | undefined;

    constructor(data?: IPaymentTypes_PaymentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PaymentTypes_PaymentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypes_PaymentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPaymentTypes_PaymentTypeDto {
    id: string;
    name: string | undefined;
}

export class Products_ProductDto implements IProducts_ProductDto {
    id!: string;
    name!: string | undefined;
    details!: ProductEntity_DetailsJson;

    constructor(data?: IProducts_ProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.details = data.details && !(<any>data.details).toJSON ? new ProductEntity_DetailsJson(data.details) : <ProductEntity_DetailsJson>this.details;
        }
        if (!data) {
            this.details = new ProductEntity_DetailsJson();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.details = _data["details"] ? ProductEntity_DetailsJson.fromJS(_data["details"]) : new ProductEntity_DetailsJson();
        }
    }

    static fromJS(data: any): Products_ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new Products_ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProducts_ProductDto {
    id: string;
    name: string | undefined;
    details: IProductEntity_DetailsJson;
}

export class HttpValidationProblemDetails implements IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: string | any;

    constructor(data?: IHttpValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: string | any;
}

export class PaymentDetails implements IPaymentDetails {

    [key: string]: any;

    constructor(data?: IPaymentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): PaymentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IPaymentDetails {

    [key: string]: any;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}